import { Injectable, Optional }     from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {SergasDevice} from "./SergasDevice";
import {Page} from "../../../model/page";

@Injectable()
export class SergasDeviceService{

  private basePath = "api/v1/sergas_device/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  private successHandler(response:string, uuid: string, windowReference: any): any{
    var result = response.split("\n")[1].split(">")[0].split("type=\"")[1];
    if ( result.startsWith("Success") ){
      let domainSegments = window.location.host.split(".");
      let target = window.location.host;
      if ( domainSegments.length > 3) {
        target = domainSegments.slice(1).slice(-3).join(".");
      }
      windowReference.location = "https://" + uuid + "." + target;
    } else {
      return Promise.reject(response);
    }
    return response;
  }

  getPage(page=0, size=20, sort="", filter=""){
    let url = this.basePath;
    let params = new HttpParams();
    params = params.append('page', page.toString())
      .append('size', size.toString())
      .append('sort', sort)
      .append('filter', filter);
    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response as Page )
      .catch(error => this.errorHandler(error));
  }



}
